import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen px-4 py-4" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4 flex-shrink-0" }
const _hoisted_3 = { class: "text-lg font-medium text-black" }
const _hoisted_4 = {
  key: 0,
  class: "p-4 mb-4 text-sm text-blue-700 bg-blue-100 rounded-lg"
}
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-black"
}
const _hoisted_7 = {
  key: 0,
  class: "flex justify-end gap-3 flex-shrink-0"
}

import { watch, ref, nextTick, onUnmounted } from "vue";

interface Props {
  title?: string;
  alert?: string;
  content?: string;
  cancelText?: string;
  confirmText?: string;
  isVisible: boolean;
  size?: "sm" | "md" | "lg" | "xl";
  hideFooter?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalComp',
  props: {
    title: { default: "Titre par défaut" },
    alert: {},
    content: { default: "" },
    cancelText: { default: "Annuler" },
    confirmText: { default: "Confirmer" },
    isVisible: { type: Boolean },
    size: {},
    hideFooter: { type: Boolean, default: false }
  },
  emits: ["update:isVisible", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const modalContent = ref<HTMLElement>();
const scrollBody = ref<HTMLElement>();

const disableBodyScroll = () => {
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
};

const enableBodyScroll = () => {
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
};

// Surveiller les changements de visibilité de la modal
watch(
  () => props.isVisible,
  (newValue) => {
    if (newValue) {
      // Attendre que le DOM soit mis à jour
      nextTick(() => {
        disableBodyScroll();
      });
    } else {
      enableBodyScroll();
    }
  },
  { immediate: true },
);

// Nettoyer lors de la destruction du composant
onUnmounted(() => {
  enableBodyScroll();
});

const closeModal = () => {
  emit("update:isVisible", false);
};

const confirmAction = () => {
  emit("confirm");
  closeModal();
};

return (_ctx: any,_cache: any) => {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-[9999] overflow-hidden",
        onWheel: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75",
            onClick: closeModal
          }),
          _createElementVNode("div", {
            class: _normalizeClass([
          'relative mx-auto w-full text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl max-h-[90vh] overflow-hidden flex flex-col',
          _ctx.size === 'sm' && 'max-w-md p-6',
          _ctx.size === 'md' && 'max-w-lg p-6',
          _ctx.size === 'lg' && 'max-w-3xl p-6',
          _ctx.size === 'xl' && 'max-w-4xl p-6',
          !_ctx.size && 'max-w-md p-6',
        ]),
            ref_key: "modalContent",
            ref: modalContent,
            onWheel: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1)
              ]),
              _createElementVNode("button", {
                onClick: closeModal,
                class: "text-black hover:text-black transition-colors",
                type: "button"
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", {
              class: "mb-4 flex-1 overflow-y-auto overscroll-contain",
              ref_key: "scrollBody",
              ref: scrollBody
            }, [
              (_ctx.alert)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-info-circle mr-2" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.alert), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "body", {}, () => [
                (_ctx.content)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.content), 1))
                  : _createCommentVNode("", true)
              ])
            ], 512),
            (!_ctx.hideFooter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
                      type: "button"
                    }, _toDisplayString(_ctx.cancelText), 1),
                    _createElementVNode("button", {
                      onClick: confirmAction,
                      class: "px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors",
                      type: "button"
                    }, _toDisplayString(_ctx.confirmText), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 34)
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

})